import _ from 'lodash';
import { createSelector } from 'reselect';

const getAccounts = state => state.accounts.all;
const getModules = state => state.content.modules;
const getModuleListLoading = state => state.modulesList.loading;
const getModuleListError = state => state.modulesList.error;
const getLessons = state => state.content.lessons;
const getProgressObjects = state => state.progress.all;
const getDischargeProgressObjects = state => state.dischargeProgress.all;
const getCurrentModuleSlug = (state, props) => props.match.params.moduleSlug;
const getCurrentModulePageSlug = (state, props) => props.match.params.pageSlug;
const getCurrentLessonSlug = (state, props) => props.match.params.lessonSlug;
const getCurrentTopicSlug = (state, props) =>
  props.match.params.partSlug || props.match.params.pageNumber;
const getCurrentPageNumber = (state, props) =>
  Number(props.match.params.pageNumber);
const getModuleIntroPages = state => state.moduleIntroPages;
const getModulePages = state => state.content.introPages;
const getLessonPages = state => state.content.lessonPages;
const getQuestions = state => state.questions;
const getDiaryEntries = state => state.entries.all;
const getDischargeSteps = state => state.dischargeSteps.data;

const getBasicRecords = state => state.basicRecords;
const getGrowthRecords = state => state.growthRecords;
const getGrowthRecordsLoading = state => state.growthRecordsLoading;
const getDietDiaperRecords = state => state.dietDiaperRecords;
const getDietDiaperRecordsLatest = state => state.dietDiaperRecordsLatest.data;
const getMilestoneRecords = state => state.milestoneRecords;
const getSleepRecords = state => state.sleepRecords;

const getModuleIdToLessonPageIdsMap = createSelector(
  getModules,
  getLessons,
  (modules, lessons) =>
    _.reduce(
      modules,
      (resultObject, module) => {
        const moduleLessonPages = _.reduce(
          lessons,
          (resultArray, lesson) => {
            if (lesson.moduleId === module.id) {
              return [...resultArray, ...lesson.pages];
            }

            return resultArray;
          },
          []
        );

        return { ...resultObject, [module.id]: moduleLessonPages };
      },
      {}
    )
);

export {
  getModuleListError,
  getModuleListLoading,
  getAccounts,
  getModules,
  getLessons,
  getProgressObjects,
  getDischargeProgressObjects,
  getCurrentModuleSlug,
  getCurrentModulePageSlug,
  getCurrentLessonSlug,
  getCurrentTopicSlug,
  getCurrentPageNumber,
  getModulePages,
  getModuleIntroPages,
  getLessonPages,
  getModuleIdToLessonPageIdsMap,
  getQuestions,
  getBasicRecords,
  getGrowthRecords,
  getDietDiaperRecords,
  getMilestoneRecords,
  getSleepRecords,
  getDiaryEntries,
  getDischargeSteps,
  getGrowthRecordsLoading,
  getDietDiaperRecordsLatest
};



// WEBPACK FOOTER //
// ./src/selectors/core.js